"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var __jsx = _react.default.createElement;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ExperienceFragmentConfig = {
  emptyLabel: 'Configure Experience Fragment',
  isEmpty: function isEmpty(props) {
    var itemsOrder = props['cqItemsOrder'];
    return !(itemsOrder && itemsOrder.length);
  }
};
var ExperienceFragment = /*#__PURE__*/function (_Container) {
  (0, _inherits2.default)(ExperienceFragment, _Container);
  var _super = _createSuper(ExperienceFragment);
  function ExperienceFragment() {
    (0, _classCallCheck2.default)(this, ExperienceFragment);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(ExperienceFragment, [{
    key: "render",
    value: function render() {
      return __jsx("div", {
        id: this.props.anchorId,
        className: "aem-ms-experience__fragment"
      }, this.childComponents);
    }
  }]);
  return ExperienceFragment;
}(_aemReactEditableComponents.Container);
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/experiencefragment')(ExperienceFragment, ExperienceFragmentConfig);
exports.default = _default;